'use strict';

export const SET_AUTH_DATA = `SET_AUTH_DATA`;
export const MARK_AS_VIEWED = `MARK_AS_VIEWED`;



// WEBPACK FOOTER //
// ./src/actions/index.js